<template>
    <!-- 其他升学途径(民族预科班、港澳招生、中外合作、海外留学) -->
    <!-- 民族预科班 -->
    <div class="studying_abroad">
        <h5>高中生海外留学指南</h5>
        <div class="content">
            <p>随着社会的发展，越来越多的高中毕业生选择出国留学道路。</p>
            <p>由于高中学生往往不够成熟，自理能力不是很好，因此高中生留学最好选择那些留学成熟国家，比如英国、澳大利亚以及加拿大等，因为这些国家会专门针对这些学生建设有各种服务体系，其教育部门对国际留学生经常遭遇到的麻烦和问题也会有更多准备。</p>
            <p>学生如果家里经济条件不错，最好选择经济教育发达的国家和适合自己学习的专业，但要注意的是避免扎堆在某一个专业学习等等。</p>
            <p>如果学生的经济条件不是特别好，可以考虑那些刚刚打开国门接受中国留学生的国家。比如韩国、意大利等。这些国家的教育水平都很不错，不是那些人口不过数十万的岛屿国家可比的；其次，这些国家因为对中国留学生开放不久，考虑到树立整体国家教育形象，他们往往会提供最好的教育，在收费上也会采取国民待遇，甚至一些国家会减免一些学费。</p>
            <p>尽管现在的高中学生留学中，商科以及计算机专业仍然热得烫手，但建议高中生还是尽量避开这些当前的热门专业，目前国内闲置着大量此类“海归”，如果自身能力不强，找工作都很麻烦。相反一些工科、市政建设等国内人才稀缺学科，不妨多考虑。选专业说到底还需要家长有一定的预见性和前瞻性，结合孩子能力，给他们一个相对好的职业发展方向。</p>

            <h6>高中生毕业生应依据特长选专业</h6>
            <p>兴趣是学习的最大动力，对于初出茅庐的高中生来说，因首先结合自己的专业特长和兴趣爱好，选择较易发挥和把握的专业，这样可以学得比较轻松，尽快适应陌生的留学环境，使得心理素质逐渐增强，也可增加父母的自信心。</p>
            <p>选专业要提前为就业做准备，要根据自己的职业发展目标和就业市场的走向，选择有发展潜力的专业。</p>
            <p>目前，中国学生大多先选院校后选专业，这种做法不科学。在国外，综合实力不强的学校并不意味着没有好的专业，而综合实力很强的学校也并非所有的专业都名列前茅。因此，先选定专业，然后才考虑在相关专业教育领域有优势的院校，这样才能提高“命中率”。</p>
            <p>从专业的角度来看，不是所有国家的专业学科都是齐全的，也不是所有国家的综合性大学都设置你喜欢的课程。而且不同国家在某些专业方面具有不同优势也是值得考虑的因素。</p>
            <p><span>美国优势专业</span>：较为全面。如电子工程专业，涉及通讯、计算机、信息产业的众多领域，实用性强且适用面广。该专业毕业生易在各类企业中找到工作，也可以自己创业，因此多年来备受青睐。在医学方面，制药专业虽然学习时间比较短，但是在美国当地的就业率相当高。不但在初入行时就能赚取高收入，而且有条件的留学生还能自己开药店。如果选择回国发展，也具有很好的前景。同领域专业如生物工程、医药卫生和医学工程等，毕业后不仅能在美国找到不错的工作，在国内也属于人才短缺专业。</p>
            <p><span>英国优势专业</span>：教育、艺术设计、文科类（社会科学）及理工类。</p>
            <p>加拿大优势专业：金融类专业持续走热。金融服务行业是加拿大经济的重要支柱之一，目前金融业所需人才主要分为：一般业务人员、财会类业务人员、个人金融理财人员、金融投资分析人员、金融财务审计师和会计师、风险管理人员等。同时，一些加拿大大学独特的专业，比如加拿大的矿业、森林业、生物工程、食品加工工艺、城市规划、视觉艺术、大众传媒与新闻、社会工作、旅游资源管理、休闲娱乐管理等，这些领域的毕业生无论在加拿大本地或是国内都有较大市场，也越来越受欢迎。</p>
            <p><span>澳大利亚优势专业</span>：护理专业受欢迎。在澳大利亚乃至全世界，护理一直被看作是一个对人类社会非常有贡献、回报又很高的职业。在近几年澳大利亚移民局公布的“移民紧缺行业清单”中，护士行业始终位列其中。此外，厨艺、面包和法式蛋糕制作、教师、园林设计、汽车修理、飞机维修和维护、采矿工程、土木工程、化学工程等专业毕业的学生毕业后不仅在澳发展良好，回国发展也是炙手可热的人才。</p>
            <p><span>德国优势专业</span>：经济、理工科（机械工程、电子工程、环保、物流等）。</p>
            <p><span>意大利优势专业</span>：设计类（服装设计、建筑设计、室内设计等专业）。</p>
            <p><span>法国优势专业</span>：艺术类（绘画、雕塑、服装设计、产品设计、造型设计、舞台设计、电影等）。</p>

            <h6>看高考成绩选留学地</h6>
            <div class="main">
                <p class="main_title">美国</p>
                <p>高考成绩不作为录取标准</p>
                <p>申请美国的院校，有无高考成绩，并不会直接作为是否录取的标准。一般来讲，申请美国院校需要托福和SAT 成绩，但是每间院校所要求的条件不同。</p>
                <p>有些学生没有托福成绩，或托福成绩不够90分，或者没有SAT 成绩，仍然可以申请到不错的美国院校。考生如果能被录取到国内的本科院校，可以一边读本科一边申请美国院校，如果所读的本科专业与所申请院校的专业相关，还可以实现转学分。</p>
                <p>对于高考失利或者是考不上自己理想学校而不读国内大学的学生，如果托福成绩在90分以上，加上高中阶段成绩和SAT成绩，可以直接申请美国的院校。高中成绩平均80分以上，托福100分以上，不管有没有SAT成绩都可以申请到全美前100名的大学。SAT1与SAT2的成绩很好的学生，可以有很大机会申请到奖学金。</p>
                <p>就算是考上中国的名校，因为对中国大学的现状非常失望而选择去美国读书。由于之前没有参加托福或者雅思考试，而又希望尽快成行，可以借助有条件录取（语言+本科双录取）前往美国读大学，一、二年级再转读美国名校，或者本科毕业升读更好的研究生院。学生最快可以在2010年9、10月份前往美国。</p>
            </div>    
            <div class="main">
                <p class="main_title">法国</p>
                <p>二本以上可申请顶级大学；成绩在二本分数线以上的学生（最好是能被国家211工程高校录取），可以申请法国最优秀的顶级大学；高考成绩在二本分数线附近或三本分数线以上学生（没被211工程高校录取），如果不是报热门专业，也可以申请一些顶级院校；成绩在大专分数线以上的学生，基本上法国各大城市的综合公立大学都可以申请；中专、职中毕业生可申请法国专门的技术型、专业型大学，可选择本科、大专学位。</p>
                <p>提醒：法国的大学有各自严格的审核录取标准，尤其在对国际学生的挑选上，是很严谨的。不能产生“在中国考不好才出国去”这样的想法，按上面所列要求来看，要考对应等级的学校，还是要达到对应等级的分数线要求的。</p>
            </div>    
            <div class="main">
                <p class="main_title">英国</p>
                <p>一本附近可申请大学预科；成绩在一本分数线附近的学生有两种选择：1、直接申请大学预科就读，可选择的院校包括全英前30名的大学，比如爱丁堡大学、巴斯大学、华威大学、谢菲尔德大学等。2、个别学校提供的文凭课程（相当于本科一年级），可选择的学校包括，布鲁奈尔大学、赫特福德大学等。</p>
                <p>成绩在专科线水平的学生</p>
                <p>可以申请到中等偏上的英国院校，比如东安格里亚大学、牛津布鲁克斯大学、诺丁汉特伦特大学等。学生可以凭借高中三年成绩进行申请，雅思要求4.5分至5.5分。无雅思成绩可参加学校的语言测试，这类考试可以让学生在短期内被学校录取和办理签证。</p>
            </div>
            <div class="main">
                <p class="main_title">加拿大</p>
                <p>成绩在二本分数线附近的学生可以直接报读加拿大的大学，但必须具备以下条件：托福90分以上；优秀的高中毕业生，三年平均分80分以上；在大学规定的申请截止时间内递出申请材料。</p>
                <p>成绩在专科线附近的学生有三种申请留学的途径：途径1：先读加拿大预科学院。这些预科学院一般都不要求提供托福成绩，大学预科需要8个月至12个月时间。被加拿大大学录取不需要考大学入学考试，但要求托福或雅思成绩，录取准则以大学预科科目的总平均分数为主。有不少学院还提供优秀大学“双录取”项目而免托福或雅思成绩。途径2：选择大学学分课程，1年后转换大学学分到大学完成学士学位。这是非常理想的升读加拿大一流大学的途径。途径3：选择入读公立社区学院，修读大学一年级、二年级课程，再转到承认学分的加拿大大学。</p>
            </div>
            <div class="main">
                <p class="main_title">新加坡</p>
                <p>各级学校对雅思都有要求</p>
                <p>高考成绩达到当地一本分数线可报读顶尖大学，如新加坡国立大学、南洋理工大学。但必须具备雅思6分、部分专业雅思6.5分（单科不低于6分）；三年平均分80分以上。</p>
                <p>高考成绩在一本至二本分数线之间可推荐报读新加坡管理学院、新加坡东亚管理学院、新加坡管理发展学院、詹姆斯库克大学新加坡校区、新加坡博伟教育集团——O/A水准课程、新加坡物流管理学院、新加坡市场管理学院、新加坡英华美学院、柯廷科技大学新加坡校区。语言要求是雅思5.5分、部分课程雅思6分或6.5分；若无雅思成绩可申请语言班；高中毕业或完成高二课程、高中平均成绩70分以上。</p>
                <p>高考成绩在三本分数线左右可以报读博伟教育集团——证书课程、新加坡市场管理学——证书课程。要求语言成绩雅思5分或5.5分；应届高中毕业生、或完成高二课程的学生。</p>
                <p>生涯规划系统提醒，虽然新加坡部分院校的开课时间比较灵活，但7、8、9月份仍然是每年的申请高峰期。由于每个学校的金牌专业报读的学生较多，一些奖学金课程也是学生争相申请的项目，因此建议学生及家长尽早报读，奖学金项目是先到先得。</p>
            </div>   
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [

            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    .studying_abroad {
        margin-left: 20px;
        background-color: #fff;
        padding: 0px 20px;
        font-size: 14px;
        h5 {
            line-height: 70px;
            font-size: 24px;
            color: #333;
            text-align: center;
            font-weight: 600;
            border-bottom: 1px solid #dedede;
        }
        .content {
            padding: 20px 0px;
            h6 {
                color: #333;
                font-size: 18px;
                font-weight: 600;
                line-height: 40px;
            }
            .main {
                padding-bottom: 10px;
                .main_title {
                    color: #2c8ffc;
                    font-size: 16px;
                    padding-left: 0px;
                }
            }
            p {
                margin-bottom: 10px;
                span {
                    color: #2c8ffc;
                }
            }
            
        }

    }
</style>